import React, { FC } from 'react';
import styled from 'styled-components';
import { CheckboxListWithSearchProps } from './shared/types';
import CheckboxListWithSearch from './CheckboxListWithSearch';
import CheckboxList from './CheckboxList';

const CheckboxListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;

const CheckboxListWithSearchContainer: FC<CheckboxListWithSearchProps> = ({
  withFormik,
  withSearch,
  withSelectAll,
  withAutocomplete,
  isLoading,
  initialOffset,
  initialLimit,
  name,
  optionsTotalCount,
  options,
  initialSelectedOptions,
  initialDisabledOptions,
  onOptionsChange,
  onOptionsFetch,
  onOptionsFetchMore,
  appliedQueryInput,
  refetchProfileFilterData,
  renderFieldLabel,
}) => {
  return (
    <CheckboxListContainer>
      {withSearch && (
        <CheckboxListWithSearch
          withFormik={withFormik}
          withSelectAll={withSelectAll}
          withAutocomplete={withAutocomplete}
          isLoading={isLoading}
          initialOffset={initialOffset}
          initialLimit={initialLimit}
          name={name}
          optionsTotalCount={optionsTotalCount}
          options={options}
          initialSelectedOptions={initialSelectedOptions}
          initialDisabledOptions={initialDisabledOptions}
          onOptionsChange={onOptionsChange}
          onOptionsFetch={onOptionsFetch}
          onOptionsFetchMore={onOptionsFetchMore}
          appliedQueryInput={appliedQueryInput}
          refetchProfileFilterData={refetchProfileFilterData}
          renderFieldLabel={renderFieldLabel}
        />
      )}
      {!withSearch && (
        <CheckboxList
          withFormik={withFormik}
          withSelectAll={withSelectAll}
          isLoading={isLoading}
          name={name}
          options={options}
          initialSelectedOptions={initialSelectedOptions}
          initialDisabledOptions={initialDisabledOptions}
          onOptionsChange={onOptionsChange}
          refetchProfileFilterData={refetchProfileFilterData}
          appliedQueryInput={appliedQueryInput}
          renderFieldLabel={renderFieldLabel}
        />
      )}
    </CheckboxListContainer>
  );
};

export default CheckboxListWithSearchContainer;
